import React from 'react';
import NavigationHeader from './NavigationHeader';
import { Form, Input, Button, ButtonToolbar, Panel, InputPicker } from 'rsuite';
import { useTranslation } from 'react-i18next';

const Support = () => {
  const { t } = useTranslation();
  const Textarea = React.forwardRef((props, ref) => (
    <Input {...props} as="textarea" ref={ref} />
  ));
  return (
    <>
      <NavigationHeader />
      <Panel style={{ margin: 50 }}>
        <h3> {t('support.heading')}</h3>
        <p>
          {t('support.message')}{' '}
          <a href="tel:+123456789">{t('support.helpline')}</a>
        </p>
        <br /> <br />
        <Form>
          <Form.Group controlId="inputPicker">
            <Form.ControlLabel>{t('support.issue.type')}</Form.ControlLabel>
            <Form.Control
              name="inputPicker"
              accepter={InputPicker}
              data={[
                {
                  label: 'Purshase',
                  value: 'Purshase',
                  role: 'Master',
                },
                {
                  label: 'Trade',
                  value: 'Kariane',
                  role: 'Master',
                },
                {
                  label: 'KYC',
                  value: 'Kariane',
                  role: 'Master',
                },
                {
                  label: 'Others',
                  value: 'Kariane',
                  role: 'Master',
                },
              ]}
            />
          </Form.Group>
          <Form.Group controlId="email">
            <Form.ControlLabel>{t('support.email')}</Form.ControlLabel>
            <Form.Control name="email" type="email" />
            <Form.HelpText tooltip>{t('support.email.help')}</Form.HelpText>
          </Form.Group>
          <Form.Group controlId="contact">
            <Form.ControlLabel>{t('support.contact')}</Form.ControlLabel>
            <Form.Control name="contact" type="contact" />
            <Form.HelpText tooltip>{t('support.contact.help')}</Form.HelpText>
          </Form.Group>
          <Form.Group controlId="textarea">
            <Form.ControlLabel>
              {t('support.issue.description')}
            </Form.ControlLabel>
            <Form.Control rows={5} name="textarea" accepter={Textarea} />
          </Form.Group>
          <Form.Group>
            <ButtonToolbar>
              <Button appearance="primary">{t('support.form.submit')}</Button>
              <Button appearance="default">{t('support.form.cancel')}</Button>
            </ButtonToolbar>
          </Form.Group>
        </Form>
      </Panel>
    </>
  );
};

export default Support;
